"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.StructuredData = void 0;
var _structuredData = _interopRequireDefault(require("./components/structured-data"));
exports.StructuredData = _structuredData["default"];